import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AdminRoutingModule} from './admin-routing.module';
import {UserAdminComponent} from './user-admin/user-admin.component';
import {AdminComponent} from './admin.component';
import {CompaniesAdminComponent} from './companies-admin/companies-admin.component';
import {FunctionBarComponent} from './common/function-bar/function-bar.component';
import {CreateUserComponent} from './user-admin/create-user/create-user.component';
import {UserDetailsComponent} from './user-admin/user-details/user-details.component';
import {ItemListComponent} from './common/item-list/item-list.component';
import {CompanyDetailsComponent} from './companies-admin/company-details/company-details.component';
import {UserListComponent} from './user-admin/user-list/user-list.component';
import {CreateCompanyComponent} from './companies-admin/create-company/create-company.component';
import {CreateBranchComponent} from './companies-admin/branch-admin/create-branch/create-branch.component';
import {MatStepperModule} from '@angular/material/stepper';
import {TranslateModule} from '@ngx-translate/core';
// eslint-disable-next-line max-len
import {CommonTudComponentsModule} from '../common/common-tud-components.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxMaskModule} from 'ngx-mask';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {EditProfileComponent} from './user-admin/edit-profile/edit-profile.component';
import {MfaModule} from '../mfa/mfa.module';
import {AccessTimesComponent} from './user-admin/create-user/access-times/access-times.component';
import {DayAccessTimeComponent} from './user-admin/create-user/access-times/day-access-time/day-access-time.component';

@NgModule({
    imports: [
        //TUD Modules
        AdminRoutingModule,
        CommonTudComponentsModule,
        MfaModule,
        //Dependencies
        CommonModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        NgxMaskModule.forChild(),
        MatStepperModule,
        FontAwesomeModule,
        NgbModule,
        FormsModule,
        UserAdminComponent,
        AdminComponent,
        CompaniesAdminComponent,
        FunctionBarComponent,
        CreateUserComponent,
        UserDetailsComponent,
        ItemListComponent,
        CompanyDetailsComponent,
        UserListComponent,
        CreateCompanyComponent,
        CreateBranchComponent,
        EditProfileComponent,
        AccessTimesComponent,
        DayAccessTimeComponent
    ],
    exports: [
        EditProfileComponent
    ]
})
export class AdminModule {
}
